import { useAppDispatch } from "@/store";
import fast from "@/assets/images/fast.png";
import {
  fetchCategoryFiltersById,
  fetchCategoryFiltersByIdWizzy,
  fetchCategoryMappingById,
  fetchSearchFilters,
  fetchSearchProductBywizzy,
  selectCategory,
} from "@/store/slices/category";
import styles from "@/styles/product_list.module.scss";
import { combineCategoryFilters } from "@/utils/combineCategoryFilters";
import Image from "next/image";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CatgeoryBreadcrumb from "../breadcrumb/breadcrumb";
import PaginationCounter from "../pagination-counter/pagination-counter";
import CollectionFilter from "./collection-filter/collection-filter";
import MetalFilter from "./metal-filter/metal-filter";
import PriceFilter from "./price-filter/price-filter";
import SortFilter from "./sort-filter/sort-filter";
import OccasionFilter from "./occasion-filter/occasion-filter";

const CatgeoryFiltersWizzy = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const categoryState = useSelector(selectCategory);
  const [showFilter, setShowFilter] = useState(false);
  const [showSort, setShowSort] = useState(false);
  const [isSearch, setIsSearch] = useState(false);

  useEffect(() => {
    if (router.route == "/jewellery") {
      setIsSearch(true);
    }
  }, [router.route]);

  useEffect(() => {
    if (!isSearch && categoryState.data) {
      dispatch(fetchCategoryMappingById(categoryState.data.id));
    }
  }, [categoryState.data, dispatch, isSearch]);

  const fastDeliveryChange = (event: any) => {
    if (isSearch) {
      router.replace(
        {
          pathname: "/jewellery",
          query: {
            ...combineCategoryFilters({
              ...router.query,
              fastDelivery: event.target.checked,
            }),
            q: router.query.q,
          },
        },
        undefined,
        { shallow: true }
      );
      return;
    }
    router.replace(
      {
        pathname: "/jewellery/category/[category]",
        query: {
          category: categoryState.data?.slug,
          ...combineCategoryFilters({
            ...router.query,
            fastDelivery: event.target.checked,
          }),
        },
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <div className="container">
      <div className="row mb-0 mt-4">
        <div className="col-12">
          {!isSearch && <CatgeoryBreadcrumb />}
          {isSearch && router.query.q && (
            <p>Search results for &apos;{router.query.q}&apos;</p>
          )}
        </div>
      </div>
      <div className={styles.desktop_filter}>
        <div className="row">
          <div className="w-100 display-fl">
            <div className={styles.filter_section}>
              <span>Filter By:</span>
              {!!categoryState?.facets?.filter(
                (v: any) => v.key == "categories"
              ).length && <CollectionFilter />}
              <PriceFilter isSearch={isSearch} />
              {!!categoryState?.facets?.filter((v: any) => v.key == "purity")
                .length && <MetalFilter isSearch={isSearch} />}
              {!!categoryState?.facets?.filter((v: any) => v.key == "occasions")
                .length && <OccasionFilter isSearch={isSearch} />}
            </div>
            {/* <div className={styles.checkbox}>
              <div className={styles.check}>
                <label
                  className="fast_red pointer"
                  htmlFor="fast-delivery-filter"
                >
                  <Image className={styles.fast} src={fast} alt="" /> Fast
                  Delivery
                </label>
                <input
                  id="fast-delivery-filter"
                  className="ml-2 fast_input"
                  type="checkbox"
                  name="check"
                  checked={router.query?.fastDelivery ? true : false}
                  onChange={fastDeliveryChange}
                />
              </div>
            </div> */}
          </div>
          <div className="col-md-9">
            <p className="mb-1 mt-3">
              <PaginationCounter />
            </p>
          </div>
          <div className="col-md-3">
            <div className={styles.filter_section2}>
              <span>Sort By:</span>
              <SortFilter isSearch={isSearch} />
            </div>
          </div>
        </div>
        <div className="cleafix"></div>
      </div>
      <div className={styles.mobile_filter}>
        <div className="row">
          <div className="col-12">
            <button
              aria-label="Filter By"
              role="button"
              onClick={() => setShowFilter(!showFilter)}
            >
              Filter By
              {!showFilter ? (
                <Image src={require("@/assets/images/plus.svg")} alt="" />
              ) : (
                <Image src={require("@/assets/images/minus.svg")} alt="" />
              )}
            </button>
          </div>
          {showFilter && (
            <>
              <div className={styles.filter_section}>
                <span>Filter By:</span>
                {!isSearch && <CollectionFilter />}
                <PriceFilter isSearch={isSearch} />
                <MetalFilter isSearch={isSearch} />
                {/* <SizeFilter isSearch={isSearch} /> */}
                <OccasionFilter isSearch={isSearch} />
              </div>
              {/* <div className={styles.checkbox}>
                <div className={styles.check}>
                  <label>
                    <Image className={styles.fast} src={fast} alt="" /> Fast
                    Delivery
                  </label>
                  <input
                    className="ml-2"
                    type="checkbox"
                    name="check"
                    onChange={fastDeliveryChange}
                  />
                </div>
              </div> */}
            </>
          )}

          <div className="col-12 mt-3">
            <button
              aria-label="Sort By"
              role="button"
              onClick={() => setShowSort(!showSort)}
            >
              Sort By
              {!showSort ? (
                <Image src={require("@/assets/images/plus.svg")} alt="" />
              ) : (
                <Image src={require("@/assets/images/minus.svg")} alt="" />
              )}
            </button>
          </div>
          {showSort && (
            <div className={styles.filter_section1}>
              <span>Sort By:</span>
              <SortFilter isSearch={isSearch} />
            </div>
          )}
          <div className="col-md-12">
            {categoryState.products?.data && (
              <p className="mb-1 mt-3">
                Showing 1 -{" "}
                {categoryState.products.size *
                  (categoryState.products.page - 1) +
                  categoryState.products.data.length}{" "}
                of {categoryState.products.totalRecords}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CatgeoryFiltersWizzy;
